import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[popup-host]',
    standalone: false
})
export class PopupHostDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}
